import { Dispatch, SetStateAction } from 'react';
import {
  Campaign,
  CampaignType_Enum as CampaignType,
  Status_Enum as CampaignStatus,
} from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { DaysOfWeek } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/bulk.pb';
import { contextFactory } from '@frontend/design-system';
import { EditorView, SaveAs, UnsavedChangesProps } from './types';

export type BulkMessageContext = {
  activeStep: number;
  attachmentMediaIds?: string[];
  audienceCount: number;
  campaignId: string;
  campaignType: CampaignType;
  consent: boolean;
  currentStatus: CampaignStatus;
  enableValidation: boolean;
  getCampaignData: () => Campaign;
  initialCampaign?: Campaign;
  locationIds: string[];
  messageCount: number;
  messageTemplate: string;
  readOnly: boolean;
  saveAs: SaveAs;
  sendDays?: DaysOfWeek;
  sendPerDay: number;
  setActiveStep: Dispatch<SetStateAction<number>>;
  setAttachmentMediaIds: Dispatch<SetStateAction<string[] | undefined>>;
  setAudienceCount: Dispatch<SetStateAction<number>>;
  setCampaignId: Dispatch<SetStateAction<string>>;
  setConsent: Dispatch<SetStateAction<boolean>>;
  setCurrentStatus: Dispatch<SetStateAction<CampaignStatus>>;
  setEnableValidation: Dispatch<SetStateAction<boolean>>;
  setLocationIds: Dispatch<SetStateAction<string[]>>;
  setMessageCount: Dispatch<SetStateAction<number>>;
  setMessageTemplate: Dispatch<SetStateAction<string>>;
  setSendDays: Dispatch<SetStateAction<DaysOfWeek | undefined>>;
  setSendPerDay: Dispatch<SetStateAction<number>>;
  setStartSendAt: Dispatch<SetStateAction<string>>;
  setSubject: Dispatch<SetStateAction<string>>;
  setTemplateId: Dispatch<SetStateAction<string | undefined>>;
  setTemplateJson: Dispatch<SetStateAction<string>>;
  setThumbnailMediaId: Dispatch<SetStateAction<string>>;
  setThumbnailUrl: Dispatch<SetStateAction<string>>;
  setTitle: Dispatch<SetStateAction<string>>;
  startSendAt: string;
  templateId?: string;
  subject: string;
  templateJson: string;
  thumbnailMediaId: string;
  thumbnailUrl: string;
  title: string;
  unsavedChangesProps: UnsavedChangesProps;
  view: EditorView;
};

export const [BulkMessageEditorContext, useBulkMessageEditorContext] = contextFactory<BulkMessageContext>(
  'useBulkMessageEditorContext must be used within a BulkMessageEditorProvider'
);
